import React from 'react';

import { useIntl } from 'react-intl';

import Link, { ILinkProps } from 'components/link';

export const CCPA_COMPLIANCE = 'ccpa-compliance';

export const CCPAButtonLink: React.FC<ILinkProps> = props => {
  const { formatMessage } = useIntl();

  return (
    <Link {...props} onPress={() => window.OneTrust.ToggleInfoDisplay()}>
      {formatMessage({ id: 'CCPADontSellButton' })}
    </Link>
  );
};

declare global {
  interface Window {
    OneTrust: {
      ToggleInfoDisplay: () => void;
    };
  }
}
